import { render } from "./SimpleApp.vue?vue&type=template&id=15802612&ts=true"
import script from "./SimpleApp.vue?vue&type=script&lang=ts"
export * from "./SimpleApp.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/stagging_env_sydney/karachi_stagging/services/amsterdam/demo1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__